import {
    FETCH_PATIENTS_REQUEST, FETCH_PATIENTS_SUCCESS, FETCH_PATIENTS_FAILURE,
    CREATE_PATIENT_SUCCESS, UPDATE_PATIENT_SUCCESS, DELETE_PATIENT_SUCCESS
  } from '../actions/patientActions';
  
  const initialState = {
    patients: [],
    loading: false,
    error: null,
  };
  
  export default function patientReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_PATIENTS_REQUEST:
        return { ...state, loading: true };
      case FETCH_PATIENTS_SUCCESS:
        return { ...state, loading: false, patients: action.payload };
      case CREATE_PATIENT_SUCCESS:
        return { ...state, patients: [...state.patients, action.payload] };
      case UPDATE_PATIENT_SUCCESS:
        return {
          ...state,
          patients: state.patients.map((patient) => patient.id === action.payload.id ? action.payload : patient),
        };
      case DELETE_PATIENT_SUCCESS:
        return {
          ...state,
          patients: state.patients.filter((patient) => patient.id !== action.payload),
        };
      default:
        return state;
    }
  }
  